import * as React from "react";
import { cn } from "../../lib/utils";
import { COLUMNS_CLASS_MAP, IMAGE_GALLERY_STYLES } from "./constants";
import type { ImageGalleryProps } from "./types";

export const ImageGallery = React.forwardRef<HTMLElement, ImageGalleryProps>(
  (
    { className, title, description, images, columns = 3, ...props },
    ref
  ) => {
    const columnsClass =
      IMAGE_GALLERY_STYLES[COLUMNS_CLASS_MAP[columns]];

    return (
      <section
        ref={ref}
        className={cn(IMAGE_GALLERY_STYLES.root, className)}
        {...props}
      >
        {title && (
          <h2 className={IMAGE_GALLERY_STYLES.title}>{title}</h2>
        )}
        {description && (
          <p className={IMAGE_GALLERY_STYLES.description}>{description}</p>
        )}

        <ul className={cn(IMAGE_GALLERY_STYLES.gridBase, columnsClass)}>
          {images.map((image) => {
            const content = (
              <>
                <div className={IMAGE_GALLERY_STYLES.imageWrapper}>
                  <img
                    src={image.imageUrl}
                    alt={image.alt}
                    className={IMAGE_GALLERY_STYLES.image}
                    loading="lazy"
            decoding="async"
                  />
                </div>
                {image.caption && (
                  <span className={IMAGE_GALLERY_STYLES.caption}>
                    {image.caption}
                  </span>
                )}
              </>
            );

            return (
              <li key={image.id} className={IMAGE_GALLERY_STYLES.item}>
                {image.href ? (
                  <a href={image.href}>{content}</a>
                ) : (
                  content
                )}
              </li>
            );
          })}
        </ul>
      </section>
    );
  }
);

ImageGallery.displayName = "ImageGallery";
